import React from 'react'
import { Typography } from '@material-ui/core'
export default function CustomText (props) {
  return (
    <div style={{ width: '7rem' }}>
      <Typography
        variant='h6'
        noWrap
        style={{
          position: 'relative',
          top: '-4px',
          zIndex: '-1000'
        }}
      >
        <small
          style={{
            fontSize: '12px',
            fontWeight: 'bold'
          }}
        >
          {props.children}
        </small>
      </Typography>
    </div>
  )
}
